const cartDrawer = document.querySelector("[data-cart-drawer]");
const cartItems = document.querySelector("[data-cart-items]");
const cartCount = document.querySelector("[data-cart-count]");
const cartSubtotal = document.querySelector("[data-cart-subtotal]");
const cartDiscount = document.querySelector("[data-cart-discount]");
const toast = document.querySelector("[data-toast]");
const navToggle = document.querySelector(".nav-toggle");
const navLinks = document.querySelector("#nav-links");
const fitmentSelect = document.querySelector("#fitmentSelect");
const searchInput = document.querySelector("#searchInput");
const sortSelect = document.querySelector("#sortSelect");
const productGrid = document.querySelector("#productGrid");

const money = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

function formatPrice(cents) {
  return money.format(cents / 100);
}

function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("is-visible");
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => {
    toast.classList.remove("is-visible");
  }, 2400);
}

function openCart() {
  cartDrawer?.classList.add("is-open");
  cartDrawer?.setAttribute("aria-hidden", "false");
}

function closeCart() {
  cartDrawer?.classList.remove("is-open");
  cartDrawer?.setAttribute("aria-hidden", "true");
}

async function getCart() {
  const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error("Could not load cart");
  return response.json();
}

async function renderCart() {
  if (!cartItems) return;
  const cart = await getCart();
  cartCount.textContent = cart.item_count;
  cartSubtotal.textContent = formatPrice(cart.total_price);

  if (cart.total_price >= 14000) {
    cartDiscount.textContent = "VIP discount unlocked. Apply LARACE20 at checkout.";
  } else {
    cartDiscount.textContent = `Spend ${formatPrice(14000 - cart.total_price)} more to unlock the VIP discount.`;
  }

  cartItems.innerHTML = "";
  if (!cart.items.length) {
    cartItems.innerHTML = '<p class="empty-cart">Your cart is ready for parts.</p>';
    return;
  }

  cart.items.forEach((item, index) => {
    const row = document.createElement("div");
    row.className = "cart-item";
    row.innerHTML = `
      <span class="cart-thumb" ${item.image ? `style="background-image:url('${item.image}');background-size:cover;background-position:center"` : ""}></span>
      <div>
        <h3>${item.product_title}</h3>
        <p>${item.quantity} x ${formatPrice(item.final_price)}</p>
      </div>
      <button type="button" data-remove-line="${index + 1}">Remove</button>
    `;
    cartItems.append(row);
  });
}

async function addVariant(variantId) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
  });

  if (!response.ok) {
    throw new Error("Could not add this product");
  }

  await renderCart();
  openCart();
  showToast("Added to cart.");
}

async function removeLine(line) {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ line: Number(line), quantity: 0 }),
  });

  if (!response.ok) {
    throw new Error("Could not update cart");
  }

  await renderCart();
}

function filterProducts() {
  if (!productGrid) return;
  const term = (searchInput?.value || "").trim().toLowerCase();
  const fitment = (fitmentSelect?.value || "all").toLowerCase();
  const cards = [...productGrid.querySelectorAll("[data-product-card]")];

  cards.forEach((card) => {
    const text = `${card.dataset.title || ""} ${card.dataset.fitment || ""}`.toLowerCase();
    const searchMatch = !term || text.includes(term);
    const fitmentMatch = fitment === "all" || text.includes(fitment);
    card.hidden = !(searchMatch && fitmentMatch);
  });
}

function sortProducts() {
  if (!productGrid || !sortSelect) return;
  const cards = [...productGrid.querySelectorAll("[data-product-card]")];
  const value = sortSelect.value;
  if (value === "price-low") {
    cards.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
  } else if (value === "price-high") {
    cards.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
  }
  cards.forEach((card) => productGrid.append(card));
  filterProducts();
}

function updateCountdown() {
  const now = new Date();
  const saleEnd = new Date(now);
  saleEnd.setHours(23, 59, 59, 999);
  const remaining = Math.max(0, saleEnd.getTime() - now.getTime());
  const values = [
    Math.floor(remaining / 3_600_000),
    Math.floor((remaining % 3_600_000) / 60_000),
    Math.floor((remaining % 60_000) / 1000),
  ];
  document.querySelectorAll("[data-countdown] b").forEach((node, index) => {
    node.textContent = String(values[index]).padStart(2, "0");
  });
}

document.addEventListener("click", async (event) => {
  const addButton = event.target.closest("[data-add-variant]");
  const removeButton = event.target.closest("[data-remove-line]");

  try {
    if (addButton) {
      await addVariant(addButton.dataset.addVariant);
    }
    if (removeButton) {
      await removeLine(removeButton.dataset.removeLine);
    }
  } catch (error) {
    showToast(error.message);
  }
});

document.querySelector("[data-cart-open]")?.addEventListener("click", async () => {
  try {
    await renderCart();
  } catch (error) {
    showToast(error.message);
  }
  openCart();
});

document.querySelector("[data-cart-close]")?.addEventListener("click", closeCart);
cartDrawer?.addEventListener("click", (event) => {
  if (event.target === cartDrawer) closeCart();
});

navToggle?.addEventListener("click", () => {
  const isOpen = navLinks.classList.toggle("is-open");
  navToggle.setAttribute("aria-expanded", String(isOpen));
});

fitmentSelect?.addEventListener("change", filterProducts);
searchInput?.addEventListener("input", filterProducts);
sortSelect?.addEventListener("change", sortProducts);

document.querySelector("#customForm")?.addEventListener("submit", (event) => {
  event.preventDefault();
  showToast("Build-help request ready. Connect this form to your preferred Shopify app.");
  event.target.reset();
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeCart();
    navLinks?.classList.remove("is-open");
    navToggle?.setAttribute("aria-expanded", "false");
  }
});

updateCountdown();
window.setInterval(updateCountdown, 1000);
